import { MessageForPlayer } from '../entities/MessageForPlayer';
import { cleavageAlreadySuggested, cleavageSuggested } from '../entities/playerMessages';
import { UseCase } from './UseCase';
export class SuggestCleavageUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.cleavage.isPublicCleavageExist(event.cleavage)
            .then(isPublicCleavageExist => isPublicCleavageExist
            ? this.applicationServices.chat.sendMessageToPlayer(new MessageForPlayer(event.username, cleavageAlreadySuggested))
            : this.onPublicCleavageExist(event))
            .catch(error => Promise.reject(error));
    }
    onPublicCleavageExist(event) {
        return this.applicationServices.cleavage.addPublicCleavage(event.cleavage)
            .then(() => this.applicationServices.chat.sendMessageToPlayer(new MessageForPlayer(event.username, cleavageSuggested(event.username, event.cleavage.title))))
            .catch(error => Promise.reject(error));
    }
}
